import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { mockData } from '../utils/mock';

export const SilentProblem = () => {
  return (
    <section id="programa" className="relative py-24 bg-zinc-900">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-orange-500/20 rounded-full mb-6">
            <AlertTriangle className="w-8 h-8 text-orange-500" />
          </div>
          <h2 className="text-4xl sm:text-5xl font-bold text-white mb-6">
            {mockData.silentProblem.title}
          </h2>
          <p className="text-xl text-white/80 mb-4">
            {mockData.silentProblem.intro}
          </p>
          <p className="text-2xl text-orange-500 font-semibold">
            {mockData.silentProblem.subtitle}
          </p>
        </div>

        <div className="grid sm:grid-cols-2 gap-6 mb-12">
          {mockData.silentProblem.problems.map((problem, index) => (
            <div
              key={index}
              className="p-6 bg-black/40 border border-white/10 rounded-xl hover:border-orange-500/50 hover:bg-black/60 transition-all duration-300 group"
            >
              <div className="flex items-start gap-4">
                <div className="flex-shrink-0 w-8 h-8 bg-orange-500/20 rounded-lg flex items-center justify-center group-hover:bg-orange-500/30 transition-colors duration-300">
                  <span className="text-orange-500 font-bold">{index + 1}</span>
                </div>
                <p className="text-lg text-white/90 group-hover:text-white transition-colors duration-300">
                  {problem}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center space-y-4 p-8 bg-gradient-to-br from-orange-500/10 via-transparent to-transparent border border-orange-500/20 rounded-2xl">
          {mockData.silentProblem.conclusion.map((line, index) => (
            <p
              key={index}
              className="text-2xl text-white font-semibold"
            >
              {line}
            </p>
          ))}
        </div>
      </div>
    </section>
  );
};
